<template>
	<section>
		<header-view></header-view>
		<nav-view></nav-view>
		<channel-item></channel-item>
	</section>
</template>

<script>
import { mapState } from 'vuex';
import HeaderView from '@/components/modules/Header.vue';
import NavView from '@/components/modules/Nav.vue';
import ChannelItem from './ChannelItem.vue';
export default {
	name: 'channel',
	components: {
		HeaderView,
		NavView,
		ChannelItem
	},
	data() {
		return {
			//
		}
	},
	computed: {
		...mapState({
            index: (state) => state.channel.index
        })
	}
}
</script>


// WEBPACK FOOTER //
// src/components/views/Channel/Channel.vue